export default __webpack_public_path__ + "static/media/text-format-16.8583e2b2.svg";